import { Enums } from '@cyborg-monorepo/hunter/common'

// HUN-1321: only companies with a Verity relationship (verityCustomerCode is
// set org-wide) and active status ever see the deprecation nudge. There's no
// per-user Verity provisioning signal, so the banner covers both "already
// set up" and "not provisioned yet" users via its own CTA + support link.
export function shouldShowVerityBanner(
  isIframe: boolean,
  verityCustomerCode: string | null | undefined,
  companyStatus: Enums.CompanyStatus | undefined,
): boolean {
  if (isIframe) return false
  if (companyStatus !== Enums.CompanyStatus.ACTIVE) return false

  return Boolean(verityCustomerCode)
}
